/**
 * sensors track api encapsulation 国内埋点上报
 * https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_web_use-7545024.html
 *
 */

import { APP_ID } from '../request/params';
import { IEventData } from '../types';
import { getCommonParams, getTrackUserInfo } from './util';
import { isBrowser, isProd } from '../utils/env';

const APP_CONFIG = {
  xingye: {
    app_id: 600,
    server_url: [
      'https://sensorsdata.glowapp.vip:8106/sa?project=default',
      isProd
        ? 'https://meerkat-prod.xaminim.com/meerkat-reporter/api/report?project=default'
        : 'https://meerkat-test.xaminim.com/meerkat-reporter/api/report?project=default',
    ],
  },
};

export class Track {
  events: IEventData[];
  reportGap: number;
  reportTimer: NodeJS.Timeout | null;
  lastReportTime: number;
  app_id: number;

  static instance: any;
  sensors: any;

  static getInstance(): Track {
    if (!Track.instance) {
      return new Track();
    }
    return Track.instance;
  }

  constructor() {
    this.events = [];
    this.reportGap = 300; // report every 300ms
    this.reportTimer = null;
    this.lastReportTime = new Date().getTime();
    this.app_id = APP_ID;
    if (isBrowser) this.init();
  }

  send = async (
    event_name: string,
    page: string,
    event_data: Record<string, unknown> = {},
    common_params: Record<string, unknown> = {}
  ) => {
    if (!this.sensors) return;

    const commonParams = getCommonParams();

    const payload = {
      event_type: '',
      page,
      ...event_data,
      ...commonParams,
      ...common_params,
    };

    await this.sensors.track(event_name, { ...payload, device_id: String(payload.device_id) });
  };

  collect = (
    event_name: string,
    page: string,
    event_data: Record<string, unknown> = {},
    common_params: Record<string, unknown> = {}
  ) => {
    if (!this.sensors) return;

    const commonParams = getCommonParams();

    const payload = {
      event_type: '',
      page,
      ...event_data,
      ...commonParams,
      ...common_params,
    };

    this.sensors.track(event_name, { ...payload, device_id: String(payload.device_id) });
  };

  async init() {
    const { server_url, app_id } = APP_CONFIG.xingye;
    this.sensors = (await import('sa-sdk-javascript')).default;

    this.sensors?.init({
      server_url: server_url,
      is_track_single_page: true,
      use_client_time: true,
      send_type: 'ajax',
      show_log: !isProd,
      heatmap: {
        clickmap: 'not_collect',
        scroll_notice_map: 'not_collect',
        collect_tags: 'not_collect',
      },
    });

    this.sensors.registerPage({
      app_id, // 公参
      env: isProd ? 'web_prod' : 'web_dev',
    });

    try {
      const userId = Number(localStorage.getItem('userId'));
      if (userId) {
        this.sensors.login(`${userId}`);
      }
    } catch (e) {
      console.error(e);
    }

    this.sensors.quick('autoTrack');
  }
}

export const getXingyeLogger = () => Track.getInstance();
